// extracted by mini-css-extract-plugin
export default {"form-fields":"styles_form-fields__oKQr0","auth-input":"styles_auth-input__oyOKA"};